import "../Challenges.css"
import React, { useState,useEffect } from "react";
import api from "views/auth/Api";
import "../../myProjects/Myprojects.css"
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { MdAssignmentInd } from "react-icons/md";
import ChallengesAssign from "./ChallengesAssign";
import { jwtDecode } from "jwt-decode";
import { message } from 'antd';
import { API_BASE_URL } from '../../../../configs/AppConfig';
import { FILES_URL } from '../../../../configs/AppConfig';
import { FiEdit } from "react-icons/fi";
import { Link } from "react-router-dom";

const ChallengeDetails = () => {

        const [data , setData] = useState([]);
        const [assign , setAssign] = useState(false);
        const { id } = useParams();
        const navigate = useNavigate();
        const [isLoading , setIsLoading] = useState(true);

        const token = localStorage.getItem('token');
        const decoded = jwtDecode(token);
        const role = decoded.role;    

        const success = () => {
            message.success('Assigned is successfully');
             };
           
     useEffect(() => {
     api.get(`${API_BASE_URL}challenges/${id}`)
      .then((response) => {  
        if (!response.data) {
          navigate(`/auth/not-found/`);
        }
        setData(response.data);
      })
      .catch((error) => {
        console.error('Error fetching card:', error);
      });
  }, [navigate,id]);


    const onClose = () => {
          setAssign(false);
        }
    const popUpAssign = async(props) => {
          setAssign(false);
                    await api.post(`${API_BASE_URL}assigned-challenge`,{
                    teamSize: props[0],
                    points: props[1],
                    class: props[2],
                    dueDate : props[3],
                    challenge: id,
                    })
                  .then(function (response) {
                            console.log("handlesubmitffff  ", response.data)
                        success();
                        // setData(response.data)
                  }).catch(error => {
                    console.log("handlesubmit error for blog get ", error)
                  });
        }
  const MyComponent=({ htmlContent }) => {
  return (
    <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
  );
}

  
  return (
    <div>
      <div className="create-header">
        <div className="Challenge-NameInfo">
        <h2>{data.challengeTitle}</h2>
        <div className="remaining-points">
         <p>{data.subject}</p>
          <p>Grade {data.grade}  </p>
          { data.voxel ? <span> VOXEL </span> : <span>{ data.teacher?.name} - {data.teacher?.school?.name} </span> }

        </div>
        {/* <div class="progress-container">
         <div class="progress-bar" ></div>
         </div> */}
          </div>
         {/* <div className="challangeHeaderImg">
         </div> */}         
      </div>
      {role === "Teacher" ?  <div className="newChallenge" onClick={() => setAssign(true)}>
                     <MdAssignmentInd className="addImg"/>
                     <span>Assign Class</span>
                    </div>
                    : null}
      {role === "Admin" ?  <Link to={`/admin/tr/challenges/edit/${id}`}><div className="newChallenge">
                     <FiEdit className="addImg"/>
                     <span>Edit Challange</span>
                    </div></Link>
                    : null}
           <div className="challangeInstr">
            <div className="pCreate">
            <div className="challangePic" style={{backgroundImage:`url(${FILES_URL}${data.coverImg?.url})`}}></div>
            <div className="flex gap-[20px]" >
             <div className="lRCreate">
             <h4 className="h4Create">Challenge Theme : </h4>
                     <MyComponent htmlContent={data.requirement?.theme}/>
     <h4 className="h4Create">Mission : </h4>
                     <MyComponent htmlContent={data.requirement?.mission}/>
     <h4 className="h4Create">Design & Submission Guidelines : </h4>
                     <MyComponent htmlContent={data.requirement?.designSubmission}/>
     </div>
     <div className="lRCreate">
     <h4 className="h4Create">Judging Criteria : </h4> 
                     <MyComponent htmlContent={data.requirement?.judgingCriteria}/>
     <h4 className="h4Create">Terms & Conditions : </h4> 
                     <MyComponent htmlContent={data.requirement?.termsConditions}/>
     <h4 className="h4Create">Nutshell : </h4> 
                     <MyComponent htmlContent={data.requirement?.nutshell}/>
     </div>
     </div>
     </div>
           </div>
           {/* <div className="challengeVideo">
           <video width="1000px" height="500" controls className="videoEdit">
       <source src="movie.mp4" type="video/mp4"/>
       <source src="movie.ogg" type="video/ogg"/>
     Your browser does not support the video tag.
     </video>
           </div> */}
           <div className="challengeVideo">
 <iframe
        src={data.videoUrl}
        style={{ border: 0, width: "1000px", height: "500px" }}
        allowFullScreen
        allow="encrypted-media"
        title="VdoCipher Video"
        className="videoEdit"
      ></iframe>     
      </div>
  {assign? <ChallengesAssign popUpAssign={popUpAssign} onClose={onClose} grade={data.grade} /> : null}
    </div>
  );
};

export default ChallengeDetails;
